/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';

import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostWasteCategory extends ResponseREST {
  data: any[];
}

export const postWasteCategory = async (): Promise<ResponseSuccessPostWasteCategory> => {
  return axiosInstance
    .post('api/waste-category/get-waste-category')
    .then((res: AxiosResponse<ResponseSuccessPostWasteCategory>) => res.data)
    .catch((err) => err);
};
